import {
  RiEdit2Fill,
  RiSendPlaneLine,
  RiEyeLine,
  RiFlightTakeoffLine,
  RiCheckboxCircleFill,
  RiHourglass2Line,
  RiCloseCircleLine,
  RiPenNibLine,
  RiForbidFill
} from '@remixicon/react';

export const formatUSPhone = (phone) => {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits[0] === '1') return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  return phone;
};

// Statuses where the operator has been committed to and money has changed
// hands — anything past SIGNED in the lifecycle. Excludes REJECTED/CANCELLED.
const PAID_QUOTE_STATUSES = new Set([
  'ACCEPTED', 'PASSENGERS_PENDING', 'WAITING_FLIGHT', 'IN_TRANSIT', 'COMPLETED', 'DIVERTED',
]);

// Per-quote revenue is `quote.total_due` — the gross amount the client paid,
// inclusive of taxes (same field Dashboard and TaxReports use). Quotes with
// no total_due don't count toward the flight count so they can't drag the
// average down.
export const computeClientSpend = (client) => {
  const flightTotals = (client?.quotes || [])
    .filter((q) => PAID_QUOTE_STATUSES.has(q.status))
    .map((q) => Number(q.total_due) || 0)
    .filter((amount) => amount > 0);

  const lifetimeValue = flightTotals.reduce((sum, n) => sum + n, 0);
  const avgFlightSpend = flightTotals.length > 0 ? lifetimeValue / flightTotals.length : 0;
  return { lifetimeValue, avgFlightSpend, flightCount: flightTotals.length };
};

export const STATUS_CONFIG = {
  DRAFT: { label: 'Draft', color: 'bg-gray-100 text-gray-600', icon: RiEdit2Fill },
  SENT: { label: 'Sent', color: 'bg-blue-50 text-blue-600', icon: RiSendPlaneLine },
  VIEWED: { label: 'Seen', color: 'bg-blue-50 text-blue-600',  icon: RiEyeLine },
  SIGNED: { label: 'Signed', color: 'bg-blue-50 text-blue-600', icon: RiPenNibLine },
  IN_TRANSIT: { label: 'In Transit', color: 'bg-amber-50 text-amber-600', icon: RiFlightTakeoffLine },
  ACCEPTED: { label: 'Paid', color: 'bg-green-150 text-green-450', icon: RiCheckboxCircleFill },
  PASSENGERS_PENDING: { label: 'Pending Passengers', color: 'bg-amberlight text-amberdark', icon: RiHourglass2Line },
  WAITING_FLIGHT: { label: 'Waiting Flight', color: 'bg-amber-50 text-amber-600', icon: RiHourglass2Line },
  REJECTED: { label: 'Rejected', color: 'bg-red-50 text-red-600', icon: RiCloseCircleLine },
  INACTIVE: { label: 'Inactive', color: 'text-gray-500 bg-gray-50 border-gray-200', icon: RiForbidFill, },
};
